import React, {useState, useEffect, useRef} from 'react'
import DataView from '../../../../UI/Dashboard/DataView'
import Ajax from '../../../../../helpers/Ajax'
import { useParams } from 'react-router-dom'
import FormGroup from '../../../../UI/Form/FormGroup'
import ErrorField from '../../../../UI/Form/ErrorField'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import DataLoader from '../../../../UI/Dashboard/DataLoader'
import Button from '../../../../UI/Form/Button'
import ContentLayout from '../../../../Common/ContentLayout'
import { toast } from 'react-toastify'
import { Helmet } from 'react-helmet-async'

export default function AmenityDetail() {
    const [infoDetail, setInfoDetail] = useState(null)
    const urlParams = useParams()
    const dataIcon = useRef()
    useEffect(()=>{
        const getResponse = setTimeout(function(){
            (async()=>{
              const response = await Ajax({
                url: `/career/heading?_id=${urlParams.HeadingId}`,
                token: true
              })
              if(response.data.status === "SUCCESS!"){
                setInfoDetail(response.data.result[0])
              }
            })()
          },100)
      
          return()=>{
            clearInterval(getResponse)
          }
    },[])

    const updateProcess = async (values, event) => {
       
        const data = {
            cultureTitle: values.cultureTitle, 
            cultureDescription: values.cultureDescription, 
            testimonialTitle: values.testimonialTitle, 
            testimonialDescription: values.testimonialDescription, 
            jobTitle: values.jobTitle, 
            jobDescription: values.jobDescription, 
            teamTitle: values.teamTitle, 
            teamDescription: values.teamDescription, 
            active: values.active == 1 ? true : false, 
        }
      
        const update = await Ajax({
            url: `/career/heading/${urlParams.HeadingId}`,
            method: 'PUT',
            token: true,
            data: data,
            loader: true
        })
        if(update.error){
            toast.error('Something Went Wrong Please Check')
        }
        if(update.data.status === "SUCCESS!"){
            toast.success(' Content Updated Successfully')
            setTimeout(function(){
                window.location.reload()
            },500)
        }
    }
    return (
        <ContentLayout title="Edit Content">
            <Helmet>
                <title>Edit Content</title>
            </Helmet>
            <DataView title="Infomation">
            {infoDetail === null ? <DataLoader/> : 
                <Formik
                    initialValues={{ 
                        cultureTitle: infoDetail.cultureTitle ? infoDetail.cultureTitle : '', 
                        testimonialTitle: infoDetail.testimonialTitle ? infoDetail.testimonialTitle : '', 
                        cultureDescription: infoDetail.cultureDescription ? infoDetail.cultureDescription : '', 
                        testimonialDescription: infoDetail.testimonialDescription ? infoDetail.testimonialDescription : '', 
                        jobTitle: infoDetail.jobTitle ? infoDetail.jobTitle : '', 
                        jobDescription: infoDetail.jobDescription ? infoDetail.jobDescription : '', 
                        teamTitle: infoDetail.teamTitle ? infoDetail.teamTitle : '', 
                        teamDescription: infoDetail.teamDescription ? infoDetail.teamDescription : '', 
                        active: infoDetail.active === true ? 1 : 2
                    }}
                    validationSchema={Yup.object({
                        cultureTitle: Yup.string().required('Field is Required'),
                        testimonialTitle: Yup.string().required('Field is Required'),
                        cultureDescription: Yup.string().required('Field is Required'),
                        testimonialDescription: Yup.string().required('Field is Required'),
                        jobTitle: Yup.string().required('Field is Required'),
                        jobDescription: Yup.string().required('Field is Required'),
                        teamTitle: Yup.string().required('Field is Required'),
                        teamDescription: Yup.string().required('Field is Required'),
                        active: Yup.string().required('Field is Required')
                    })}
                    onSubmit={(values, event) => {
                        updateProcess(values, event)
                    }}
                >
                <Form>
                    <div className='row'>
                    <div className='col-md-6'>
                            <FormGroup label="Our Culture Heading" required>
                                <Field placeholder='Our Culture Heading' name="cultureTitle" className='form-control' />
                                <ErrorField><ErrorMessage name="cultureTitle"/></ErrorField>
                            </FormGroup>
                        </div>
                       
                        <div className='col-md-12'>
                            <FormGroup label="Our Culture Description" required>
                                <Field as="textarea" name="cultureDescription"  className='form-control' />
                                <ErrorField><ErrorMessage name="cultureDescription"/></ErrorField>
                            </FormGroup>
                        </div>

                        <div className='col-md-6'>
                            <FormGroup label="Testimonial Heading" required>
                                <Field placeholder='Testimonial Heading' name="testimonialTitle" className='form-control' />
                                <ErrorField><ErrorMessage name="testimonialTitle"/></ErrorField>
                            </FormGroup>
                        </div>
                       
                        <div className='col-md-12'>
                            <FormGroup label="Testimonial Description" required>
                                <Field as="textarea" name="testimonialDescription"  className='form-control' />
                                <ErrorField><ErrorMessage name="testimonialDescription"/></ErrorField>
                            </FormGroup>
                        </div>

                        <div className='col-md-6'>
                            <FormGroup label="Job Heading" required>
                                <Field placeholder='Job Heading' name="jobTitle" className='form-control' />
                                <ErrorField><ErrorMessage name="jobTitle"/></ErrorField>
                            </FormGroup>
                        </div>
                       
                        <div className='col-md-12'>
                            <FormGroup label="Job Description" required>
                                <Field as="textarea" name="jobDescription"  className='form-control' />
                                <ErrorField><ErrorMessage name="jobDescription"/></ErrorField>
                            </FormGroup>
                        </div>

                        <div className='col-md-6'>
                            <FormGroup label="Team Heading" required>
                                <Field placeholder='Team Heading' name="teamTitle" className='form-control' />
                                <ErrorField><ErrorMessage name="teamTitle"/></ErrorField>
                            </FormGroup>
                        </div>
                       
                        <div className='col-md-12'>
                            <FormGroup label="Team Description" required>
                                <Field as="textarea" name="teamDescription"  className='form-control' />
                                <ErrorField><ErrorMessage name="teamDescription"/></ErrorField>
                            </FormGroup>
                        </div>
                       
                        <div className='col-md-6'>
                        <FormGroup label="Active" required>
                        <Field as="select" name="active" className='form-select'>
                            <option value="1">Enable</option>
                            <option value="2">Disable</option>
                        </Field>
                        <ErrorField><ErrorMessage name="type"/></ErrorField>
                    </FormGroup>
                    </div>
                  
                    </div>
                   
                    <div className='col-md-2 d-grid'>
                        <Button type="submit">Update</Button>
                    </div>
                </Form>
                </Formik> }
            </DataView>
        </ContentLayout>
    )
}
